import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';

// import routeConfigs from '@src/pages/app-router/route-configs';
// import { delay } from '@src/utils/common-util';
// import AntdMessage from '@src/components/antd/message';
// import { $$tracker } from '@src/tracker';

class DownLoadStore extends BaseStore {
  use() {
    super.use();

    useMount(() => { });
    useEffect(() => { }, []);
  }
}

export default DownLoadStore;
